


function Homepage () {


    return(
        <div> 
            <h1 className="content">Welcome to Tessera!</h1>
            <h4 className="define">Pronounced (teh-sr-uh) a small tablet of (bone, wood, or ivory) used as a token or ticket for means of identification in Ancient Greece. Today we use passwords as a means of identification for our devices and apps. </h4>
            


        </div>
    )
}

export default Homepage